import { render, staticRenderFns } from "./HomeNewsList.vue?vue&type=template&id=9c6e94b6&scoped=true&"
import script from "./HomeNewsList.vue?vue&type=script&lang=js&"
export * from "./HomeNewsList.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewsList.vue?vue&type=style&index=0&id=9c6e94b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6e94b6",
  null
  
)

export default component.exports